import { useQuery } from '@tanstack/vue-query';
import { RestaurantTimeslot } from '@pasta-evangelists/pasta-types';
import { queries } from '@/api/queries';
import dayjs from 'dayjs';
import { getApiV2RestaurantsIdTimeSlots } from '@/api/pensa';

interface Params {
  restaurantId: string | null;
  fulfillmentType: 'delivery' | 'pickup' | 'eat_in';
  date?: string | null;
}

const sortTimeSlots = (a: RestaurantTimeslot, b: RestaurantTimeslot) => {
  if (a.startTime === 'asap') return -1;
  return +new Date(a.startTime) - +new Date(b.startTime);
};

const useGetTimeslots = (params: Ref<Params>) => {
  const restaurantId = computed(() => params.value.restaurantId);
  const fulfillmentType = computed(() => params.value.fulfillmentType);
  const date = computed(() => params.value.date ?? null);
  const enabled = computed(() => !!restaurantId.value && params.value.fulfillmentType !== 'eat_in');
  return useQuery({
    ...queries.takeaway.restaurant(restaurantId)._ctx.timeslots(fulfillmentType, date),
    queryFn: () =>
      getApiV2RestaurantsIdTimeSlots(restaurantId.value!, {
        fulfillment_type: fulfillmentType.value,
        travel_to_date_time: date.value ?? undefined,
      }),
    enabled,
    refetchInterval: 1000 * 60,
    select: data => {
      const copyDate = [...data];
      return copyDate
        .sort(sortTimeSlots)
        .filter(
          timeslot => timeslot.startTime === 'asap' || dayjs(timeslot.endTime).isAfter(dayjs())
        );
    },
  });
};

export default useGetTimeslots;
